/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {WealthyEnv} from "helpers";

const pwpSuccessStories = [
  {
    id: 1,
    managerName: "Srimanta",
    date: "Since April, 2019",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/pwp-success-story-srimanta-avatar.png`,
    description: "3 years back, I moved from ICICI Securities because I wanted to break free from product quota, and have a fair and transparent earnings structure. I found everything I wanted and more with Wealthy.",
    mainExperience: "8+ years of experience,",
    pastExperience: "Ex -ICICI Securities"
  },
  {
    id: 2,
    managerName: "Varun",
    date: "Since Feb 2020",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/pwp-success-story-varun-avatar.png`,
    description: "I moved from International Money Matters to give my clients a better digital experience. Now, It’s been more than 2 years with Wealthy and I can now say it was the right move for me and my clients.",
    mainExperience: "11+ years of experience,",
    pastExperience: "Ex- Northern Trust, IMM"
  },
  {
    id: 3,
    managerName: "Priyam",
    date: "Since March 2021",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/pwp-success-story-priyam-avatar.png`,
    description: "I moved from ICICI Wealth to focus purely on Wealth management for my clients. Now, I have a much wider product basket that helped me assist my clients in growing their Wealth.",
    mainExperience: "6+ Years of experience,",
    pastExperience: "Ex ICICI Bank"
  },
  {
    id: 4,
    managerName: "Dhananjay",
    date: "Since Dec, 2021",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/pwp-success-story-dhananjay-avatar.png`,
    description: "After my stint as a Burgundy RM with Axis Bank, I wanted to become an entrepreneur. Wealthy’s Private Wealth program gave me the security of a job and earnings & freedom of an entrepreneur.",
    mainExperience: "7+ Years of experience,",
    pastExperience: "Ex Axis Bank, Kotak Bank"
  }

];

export default pwpSuccessStories;
